<template>
  <div class="AideContactComponent">
    <div class="headerBlock">
      <BasicIcon
        name="tableauDeBord"
        class="headerBlock--background"
      />
      <div class="headerBlock--label">
        <BasicText size="h5">{{ conf.pageTitle }}</BasicText>
        <BasicText>{{ conf.pageSubtitle }}</BasicText>
      </div>
    </div>
    <div class="blockWrapper">
      <div class="reusableBlock reusableBlock--link">
        <span class="sectionTitle">Guides pratiques</span>
        <div
          class="reusableBlock reusableBlock--linkElement"
          v-for="(elem, index) of computedLink"
          :key="index"
        >
          <BasicLink
            :label="elem.title"
            :href="elem.link"
          />
        </div>
      </div>
      <div class="reusableBlock reusableBlock--contact">
        <BasicCard
          :title="conf.blocContact.title"
          :subtitles="[{ text: conf.blocContact.phone, icon: 'phone' }]"
        />
        <BasicText size="body-m">
          Notre équipe est joignable (heure de Paris) :
          <ul>
            <li>du lundi au jeudi de 9h à 12h30 et de 13h30 à 17h00</li>
            <li>le vendredi de 9h à 12h et de 13h30 à 16h30</li>
          </ul>
        </BasicText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useAppStateStore } from '@/features/application'
  import type { TypePermissionLike } from '@/features/domaine/types/opco'
  import { computed } from 'vue'
  import jsonConfiguration from './AideContact.json'

  type Configuration = typeof jsonConfiguration
  const conf = computed<Configuration>(() => jsonConfiguration)

  const appState = useAppStateStore()

  const computedLink = computed(() =>
    conf.value.liens.filter(
      (x) =>
        (x.context as readonly number[]).includes(appState.contextCourant) &&
        (x.permissions === null || appState.autoriseLecture(...(x.permissions as TypePermissionLike[]))),
    ),
  )
</script>

<style lang="less" scoped>
  @import './AideContactComponent.less';
</style>
